import { HiOutlineChevronDown } from "react-icons/hi"
import { IoChevronBackOutline, IoDocumentTextOutline, IoImageOutline } from "react-icons/io5"
import { VscSmiley } from "react-icons/vsc"
import {ImAttachment} from "react-icons/im"
import { AbsoluteContainer, AppLabel, AppSpan, AppText, Button, CustomContainer, Divider, FixedContainer, FlexColumn, FlexRow, GridContainer, Input } from "src/style"

export const ConversationChats: React.FC<any> = ({data, back}) => {

    return (
        <CustomContainer style={{whiteSpace: 'normal'}} >
            <FlexRow topMargin="2.5" justifyContent="space-between" wrap="wrap" gap="2">
                <FlexRow rightMargin="1.5" width="auto" sizeUnit="">
                    <GridContainer 
                        height='3' width='3.2' borderColor=' #E4ECF7' 
                        radius='0.4' rightMargin='2'
                        onClick={back}
                    >
                        <IoChevronBackOutline className='back-icon' />
                    </GridContainer>
                    <AppText textSize="1.8" fontWeight="700" color="#27272E">{data?.title}</AppText>
                </FlexRow>
                <FlexRow width="auto" sizeUnit="">
                    <CustomContainer rightMargin="3" width="auto" sizeUnit="">
                        <AppLabel textSize="1" color="#A0AEC0">Priority</AppLabel>
                        <CustomContainer>
                            <AppSpan 
                                textSize="1.2" fontWeight="600" rightMargin="2"
                                color={data?.priority === 'Low' ? '#4AAE8C' : data?.priority === 'Medium' ? '#F7936F' : '#F16063'}
                            >
                                {data?.priority || 'Low'}
                            </AppSpan>
                            <AppSpan textSize="1.6" color="#1A202C"><HiOutlineChevronDown /></AppSpan>
                        </CustomContainer>
                    </CustomContainer>
                    <CustomContainer rightMargin="3" width="auto" sizeUnit="">
                        <AppLabel textSize="1" color="#A0AEC0">Status</AppLabel>
                        <CustomContainer>
                            <AppSpan 
                                textSize="1.2" fontWeight="600" rightMargin="2"
                                color={data?.status === 'Open' ? '#4C6FFF' : data?.status === 'Unresolved' ? '#F16063' : '#4AAE8C'}
                            >
                                {data?.status}
                            </AppSpan>
                            <AppSpan textSize="1.6" color="#1A202C"><HiOutlineChevronDown /></AppSpan>
                        </CustomContainer>
                    </CustomContainer>
                    <CustomContainer rightMargin="3" width="auto" sizeUnit="">
                        <AppLabel textSize="1" color="#A0AEC0">Department</AppLabel>
                        <CustomContainer>
                            <AppSpan textSize="1.2" fontWeight="600" color="#1A202C" rightMargin="2">{data?.department}</AppSpan>
                            <AppSpan textSize="1.6" color="#1A202C"><HiOutlineChevronDown /></AppSpan>
                        </CustomContainer>
                    </CustomContainer>
                    <CustomContainer rightMargin="3" width="auto" sizeUnit="">
                        <AppLabel textSize="1" color="#A0AEC0">AssignedTo</AppLabel>
                        <CustomContainer>
                            <AppSpan textSize="1.2" fontWeight="600" color="#1A202C" rightMargin="2">{data?.assignedTo}</AppSpan>
                            <AppSpan textSize="1.6" color="#1A202C"><HiOutlineChevronDown /></AppSpan>
                        </CustomContainer>
                    </CustomContainer>
                </FlexRow>
            </FlexRow>
            <Divider bgColor="rgba(237, 242, 247, 0.5)" margin="3" />
            <CustomContainer topPadding="2" bottomPadding="15" overflow="auto" minHeight="15" mnHUnit="vh" maxHeight="50" mxHUnit="vh">
                <FlexColumn justifyContent="flex-start" alignItems="flex-start" topMargin="2">
                    <CustomContainer maxWidth="40" padding="1.2" bgColor="#E1E8FF" radius="0.5">
                        <AppText textSize="1.2">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod 
                            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad 
                        </AppText>
                    </CustomContainer>
                    <AppSpan textSize="1" fontWeight="500" topMargin="1">2 hours ago</AppSpan>
                </FlexColumn>
                <FlexColumn justifyContent="flex-start" alignItems="flex-end" topMargin="2">
                    <CustomContainer maxWidth="40" padding="1.2" bgColor="#F7FAFC" radius="0.5">
                        <AppText textSize="1.2">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod 
                            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad 
                        </AppText>
                    </CustomContainer>
                    <AppSpan textSize="1" fontWeight="500" topMargin="1">2 hours ago</AppSpan>
                </FlexColumn>
                <FlexColumn justifyContent="flex-start" alignItems="flex-start" topMargin="2">
                    <CustomContainer maxWidth="40" padding="1.2" bgColor="#E1E8FF" radius="0.5">
                        <AppText textSize="1.2">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod 
                            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad 
                        </AppText>
                    </CustomContainer>
                    <AppSpan textSize="1" fontWeight="500" topMargin="1">2 hours ago</AppSpan>
                </FlexColumn>
                <FlexColumn justifyContent="flex-start" alignItems="flex-end" topMargin="2">
                    <CustomContainer maxWidth="40" padding="1.2" bgColor="#F7FAFC" radius="0.5">
                        <AppText textSize="1.2">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod 
                            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad 
                        </AppText>
                    </CustomContainer>
                    <AppSpan textSize="1" fontWeight="500" topMargin="1">2 hours ago</AppSpan>
                </FlexColumn>
                <FlexColumn justifyContent="flex-start" alignItems="flex-end" topMargin="2">
                    <CustomContainer maxWidth="40" padding="1.2" bgColor="#F7FAFC" radius="0.5">
                        <AppText textSize="1.2">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod 
                            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad 
                        </AppText>
                    </CustomContainer>
                    <AppSpan textSize="1" fontWeight="500" topMargin="1">2 hours ago</AppSpan>
                </FlexColumn>
            </CustomContainer>
            <FixedContainer className="conversation-chat-fix-position" bottom="1" left="53" bgColor="#ffffff">
                <CustomContainer height="15.8"  radius="0.6" borderColor="#D3D8DD" topMargin="2">
                    <Input 
                        textSize="1.2" color="#031849" 
                        style={{borderBottom: '1px solid #D3D8DD'}}
                        rightPadding="1" leftPadding="1" height="3.7" 
                        placeholder="Reply"
                    />
                    <AbsoluteContainer bottom="0" left="0" width="100" sizeUnit="%">
                        <FlexRow justifyContent="space-between" leftPadding="1.5" rightPadding="1.5" bottomPadding="1">
                            <FlexRow width="auto" sizeUnit="" rightMargin="2" gap="2">
                                <VscSmiley className="chat-input-icons" />
                                <IoImageOutline className="chat-input-icons" />
                                <ImAttachment className="chat-input-icons" />
                                <IoDocumentTextOutline className="chat-input-icons" />
                            </FlexRow>
                            <Button
                                width='5.7' borderColor='#4C6FFF' height='2.6'
                                hoverBgColor='#ffffff' hoverColor='#4C6FFF' 
                                radius="0.4" titleSize="1.1"
                            >
                                Send
                            </Button>
                        </FlexRow>
                    </AbsoluteContainer>
                </CustomContainer>
            </FixedContainer>
        </CustomContainer>
    )
}